import { z } from 'zod';

export const CoreElasticsearchMaidModelMaxTimestampScalarFieldEnumSchema = z.enum(['id','modelName','maxTimestamp']);

export default CoreElasticsearchMaidModelMaxTimestampScalarFieldEnumSchema;
